import { render, staticRenderFns } from "./revenueBills-details.vue?vue&type=template&id=c4612a80&scoped=true&"
import script from "./revenueBills-details.vue?vue&type=script&lang=js&"
export * from "./revenueBills-details.vue?vue&type=script&lang=js&"
import style0 from "./revenueBills-details.vue?vue&type=style&index=0&id=c4612a80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4612a80",
  null
  
)

export default component.exports